<template>
  <section class="section full-height">
    <div class="buttons">
      <b-button
        size="is-large"
        @click="$router.push({ name: 'admin.institutions.new' })"
        type="is-info"
      >
        <b-icon size="is-small" pack="fas" icon="plus" />
        {{ $t('Añadir Institución') }}</b-button
      >
    </div>

    <ReactiveBase
      :app="appbaseParams.app"
      :type="appbaseParams.type"
      :credentials="appbaseParams.creds"
    >
      <div class="columns">
        <div class="column is-3">
          <b-field>
            <b-button
              @click="clearFilters()"
              size="is-small"
              icon-left="broom"
              type="is-warning"
            ></b-button>
          </b-field>
          <filter-selector
            v-for="sensor in sensorFilters"
            :key="sensor.id"
            :componentId="sensor.id"
            :dataField="sensor.field"
            :title="sensor.title"
            :sensors="sensors"
          />
        </div>
        <div class="column is-9">
          <div class="columns">
            <div class="column">
              <data-search
                ref="searchField"
                componentId="SearchSensor"
                :autosuggest="true"
                :highlight="true"
                :showFilter="true"
                queryFormat="and"
                :placeholder="$t('Buscar')"
                :fuzziness="0"
                :debounce="100"
                :URLParams="true"
                :dataField="['companyName', 'companyReference']"
                :react="{
                  and: [
                    'SectorSensor',
                    'CompanyTypeSensor',
                    'CountrySensor',
                    'CountriesSensor',
                    'FundraisingOportunitySensor',
                    'FundraisingProgramSensor',
                    'RequesterCompanySensor',
                    'CurrencySensor',
                    'EbidtaSensor',
                    'RequestedAmountSensor'
                  ]
                }"
              />
            </div>
            <div class="column is-2">
              <b-field>
                <b-select v-model="perPage">
                  <option value="10" key="10">10</option>
                  <option value="25" key="25">25</option>
                  <option value="50" key="50">50</option>
                  <option value="100" key="100">100</option>
                  <option value="200" key="200">200</option>
                </b-select>
              </b-field>
            </div>
            <div class="column">
              <saved-searches-selector />
            </div>
          </div>

          <ReactiveList
            componentId="SearchResult"
            dataField="companyName"
            :pagination="true"
            paginationAt="top"
            :size="perPage"
            :stream="false"
            :showResultStats="true"
            class="result-list-container"
            :innerClass="{ list: 'results-container' }"
            :react="{
              and: [
                'SectorSensor',
                'SearchSensor',
                'CompanyTypeSensor',
                'CountrySensor',
                'CountriesSensor',
                'FundraisingOportunitySensor',
                'FundraisingProgramSensor',
                'RequesterCompanySensor',
                'CurrencySensor',
                'EbidtaSensor',
                'RequestedAmountSensor'
              ]
            }"
          >
            <div slot="render" slot-scope="{ data }">
              <result-list-wrapper>
                <b-tabs>
                  <b-tab-item label="List" icon="format-list-bulleted">
                    <table
                      class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
                    >
                      <thead>
                        <tr>
                          <th>{{ $t('Referencia organización') }}</th>
                          <th>{{ $t('Nombre organización') }}</th>
                          <th>{{ $t('País') }}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-bind:key="result._id" v-for="result in data">
                          <td>
                            <a @click="showInstitutionDetail(result)">
                              {{ result._id }}
                            </a>
                          </td>
                          <td>
                            <b-tooltip :label="result.companyName">
                              <p
                                style="white-space: nowrap;
                              overflow: hidden;
                              cursor: pointer;
                              text-overflow: ellipsis;
                              max-width: 550px;"
                              >
                                {{ result.companyName }}
                              </p>
                            </b-tooltip>
                          </td>
                          <td>
                            <span>{{ $t(result.country) }}</span>
                          </td>
                          <td>
                            <b-field>
                              <p class="control">
                                <button
                                  size="is-small"
                                  @click="goToInstitutionEdit(result._id)"
                                  class="button"
                                >
                                  <b-icon
                                    size="is-small"
                                    pack="fas"
                                    icon="pencil-alt"
                                  ></b-icon>
                                </button>
                              </p>
                              <p class="control">
                                <button
                                  size="is-small"
                                  @click="goToInstitutionDetail(result._id)"
                                  class="button"
                                >
                                  <b-icon
                                    size="is-small"
                                    type="is-info"
                                    pack="fas"
                                    icon="eye"
                                  ></b-icon>
                                </button>
                              </p>
                              <p class="control">
                                <button
                                  size="is-small"
                                  @click="
                                    removeInstitution(result.companyReference)
                                  "
                                  class="button"
                                >
                                  <b-icon
                                    size="is-small"
                                    type="is-danger"
                                    pack="fas"
                                    icon="trash"
                                  ></b-icon>
                                </button>
                              </p>
                            </b-field>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-tab-item>
                  <b-tab-item label="Map" icon="map">
                    <GmapMap
                      :center="{ lat: 0, lng: 0 }"
                      :zoom="1"
                      map-type-id="terrain"
                      style="width: 100%; height: 600px"
                    >
                      <GmapMarker
                        v-bind:key="result._id"
                        v-for="result in data"
                        :position="{ lat: result.lat, lng: result.lng }"
                        :clickable="true"
                        :draggable="true"
                        @click="showInstitutionDetail(result)"
                      />
                    </GmapMap>
                  </b-tab-item>
                </b-tabs>
              </result-list-wrapper>
            </div>
          </ReactiveList>
        </div>
      </div>
    </ReactiveBase>
  </section>
</template>

<script>
import Fetcher from '@/mixins/fetcher.js'
import { mapActions } from 'vuex'
import { Auth } from 'aws-amplify'
import FilterSelector from '@/components/admin/institutions/FilterSelector'
import SavedSearchesSelector from '@/components/admin/institutions/SavedSearchesSelector'

const ndjsonParser = require('ndjson-parse')

export default {
  name: 'AdminOnBoardRequestsTable',
  components: { FilterSelector, SavedSearchesSelector },
  mixins: [Fetcher],
  props: {},
  data() {
    return {
      perPage: 25,
      sensorFilters: [
        {
          id: 'CompanyTypeSensor',
          field: 'companyType.keyword',
          title: 'Tipo de organización'
        },
        {
          id: 'SectorSensor',
          field: 'businessSectors.keyword',
          title: 'Sector actividad operativa'
        },
        {
          id: 'CountriesSensor',
          field: 'countries.keyword',
          title: 'Jurisdicción operativa positiva'
        },
        {
          id: 'FundraisingOportunitySensor',
          field: 'fundraisingOportunityPhases.keyword',
          title: 'Fase oportunidad recaudación/fundraising'
        },
        {
          id: 'FundraisingProgramSensor',
          field: 'fundraisingProgramTypes.keyword',
          title: 'Tipos de programas de capital en Recaudación/Fundraising'
        },
        {
          id: 'RequesterCompanySensor',
          field: 'requesterCompanyTypes.keyword',
          title: 'Tipo de organización aceptadas'
        },
        {
          id: 'CurrencySensor',
          field: 'programCurrencyTypes.keyword',
          title: 'Criterios de Divisas o Moneda Programa'
        },
        {
          id: 'EbidtaSensor',
          field: 'ebidtaAmountRanges.keyword',
          title: 'Criterios de Cifra de EBITDA para organización'
        },
        {
          id: 'RequestedAmountSensor',
          field: 'requestedAmountRanges.keyword',
          title: 'Criterios de importes de programas de Capital'
        },
        {
          id: 'CountrySensor',
          field: 'country.keyword',
          title: 'País'
        }
      ]
    }
  },
  computed: {
    appbaseParams() {
      return {
        app: process.env.VUE_APP_APPBASE_APP,
        type: process.env.VUE_APP_APPBASE_TYPE,
        creds: process.env.VUE_APP_APPBASE_CREDS
      }
    },
    sensors() {
      return this.sensorFilters.map(f => f.id)
    }
  },
  methods: {
    ...mapActions('institutions', ['deleteInstitution', 'postSaveSearch']),
    async transformAppbaseResponse(response) {
      this.$Progress.finish()
      return response
    },
    async transformAppbaseRequest(req) {
      this.$Progress.start()
      req.headers.Authorization = (await Auth.currentSession()).idToken.jwtToken
      const parsedNdjson = ndjsonParser(req.body).filter(function(elem, idx) {
        if (idx % 2 > 0) {
          return elem
        }
      })
      req.body = JSON.stringify({ queries: parsedNdjson })
      return req
    },
    showInstitutionDetail(institution) {
      let self = this
      self.$dialog.alert({
        title: institution.companyReference,
        message:
          '<p>' +
          institution.companyName +
          '</p>' +
          '<p>' +
          self.$t(institution.companyType) +
          '</p>' +
          '<p>' +
          institution.country +
          '</p>',
        canCancel: true,
        confirmText: self.$t('Detalle'),
        cancelText: self.$t('Cerrar'),
        onConfirm: function() {
          self.goToInstitutionDetail(institution.companyReference)
        }
      })
    },
    goToInstitutionDetail(id) {
      this.$router.push({
        name: 'admin.institutions.detail',
        params: { id: id }
      })
    },
    goToInstitutionEdit(id) {
      this.$router.push({ name: 'admin.institutions.edit', params: { id: id } })
    },
    clearFilters() {
      this.$router.replace({
        ...this.$router.currentRoute,
        query: {}
      })
    },
    removeInstitution(id) {
      let self = this
      self.$dialog.confirm({
        message: self.$t('¿Estás seguro? esta operación no se puede deshacer'),
        type: 'is-danger',
        onConfirm: function() {
          self.request(() =>
            self.deleteInstitution(id).then(function() {
              self.$dialog.confirm({
                message: self.$t('Institución eliminada'),
                type: 'is-success',
                onConfirm: function() {
                  location.reload()
                }
              })
            })
          )
        }
      })
    },
    setSearchField() {
      this.$refs.searchField.setValue('')
    }
  },
  mounted() {
    let self = this
    self.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', self.$t(self.$route.meta.title)],
      title: self.$t(self.$t(self.$route.meta.title))
    })
  }
}
</script>

<style lang="scss">
.book-content {
  padding: 20px 10px;
  background: #f3f7f6;

  &:nth-child(odd) {
    background: #e8f2f0;
  }
  .title {
    font-size: 19px !important;
    font-weight: bold;
    color: #333;
  }
  a {
    color: #d00a6e;
    font-weight: 600;
  }
}
.result-list-container > p {
  margin-top: 20px;
}
</style>
